export const navItems = [
  { id: 'media', label: '视频爆料', href: '#media' },
  { id: 'features', label: '平台特色', href: '#features' },
  { id: 'app', label: '手机刷瓜', href: '#app' },
  { id: 'topics', label: '热门话题', href: '#topics' },
  { id: 'about', label: '关于我们', href: '#about' },
  { id: 'faq', label: '常见问题', href: '#faq' },
];

export const cardsData = [
  {
    id: 1,
    title: '顶流男星深夜密会神秘女子，酒店共度8小时',
    tag: '独家爆料',
    tagType: 'primary',
    excerpt: '据知情人士透露，该男星近期正在拍摄新剧，却在收工后直奔某五星级酒店，与一名身材高挑的女子先后进入同一房间，直至次日清晨才分别离开。',
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20nighttime%20luxury%20hotel%20exterior%20scene%20with%20warm%20golden%20lighting%20spilling%20from%20entrance%2C%20paparazzi%20style%20composition%2C%20dark%20moody%20atmosphere%20with%20red%20accents%2C%20cinematic%20lighting%2C%20editorial%20photography%20style&width=800&height=500&seq=card-1&orientation=landscape',
    stats: { views: '128.6万', comments: '3.2万' },
  },
  {
    id: 2,
    title: '当红花旦片场耍大牌？剧组工作人员集体爆料',
    tag: '热榜第一',
    tagType: 'accent',
    excerpt: '多位剧组工作人员匿名向本平台投稿，称某85后花旦在拍摄期间多次迟到、对工作人员呼来喝去，甚至因为化妆不满意当场罢拍三小时，导致全组进度严重滞后。',
    image: 'https://readdy.ai/api/search-image?query=A%20film%20set%20behind%20the%20scenes%20with%20dramatic%20tension%2C%20director%20chair%20and%20professional%20lighting%20equipment%2C%20warm%20cinematic%20glow%2C%20editorial%20photojournalism%20style%2C%20moody%20atmosphere&width=800&height=500&seq=card-2&orientation=landscape',
    stats: { views: '96.3万', comments: '2.8万' },
  },
  {
    id: 3,
    title: '某综艺节目黑幕曝光：淘汰名单提前内定',
    tag: '深度追踪',
    tagType: 'primary',
    excerpt: '内部工作人员泄露的聊天记录显示，某热门选秀综艺的淘汰顺序早在开播前就已确定，所谓的观众投票只是走过场，多位选手的名次与实际人气严重不符。',
    image: 'https://readdy.ai/api/search-image?query=A%20reality%20TV%20show%20stage%20with%20dramatic%20spotlights%20and%20dark%20backstage%20area%2C%20contrast%20between%20bright%20stage%20and%20shadow%20backstage%2C%20theatrical%20lighting%2C%20editorial%20style%20with%20warm%20red%20accents&width=800&height=500&seq=card-3&orientation=landscape',
    stats: { views: '87.1万', comments: '4.5万' },
  },
  {
    id: 4,
    title: '知名导演被曝婚内出轨，第三者竟是其新片女主角',
    tag: '重磅实锤',
    tagType: 'accent',
    excerpt: '多方证据链显示，该导演在婚姻存续期间与多名女演员保持不正当关系，其中一位正是其即将上映新片的女主角，两人在片场的亲密互动也被多名目击者证实。',
    image: 'https://readdy.ai/api/search-image?query=A%20film%20director%20chair%20on%20empty%20movie%20set%20at%20night%2C%20dramatic%20shadows%20and%20warm%20spotlight%2C%20moody%20cinematic%20atmosphere%2C%20editorial%20photojournalism%2C%20dark%20and%20mysterious%20tone&width=800&height=500&seq=card-4&orientation=landscape',
    stats: { views: '112.4万', comments: '5.1万' },
  },
  {
    id: 5,
    title: '某流量小生代言费曝光，天价数字令人咋舌',
    tag: '数据解密',
    tagType: 'primary',
    excerpt: '一份疑似品牌方的内部报价单流出，该小生单次商业代言报价高达八位数，远超同级别艺人。业内人士分析，虚高报价背后可能涉及复杂的利益输送链条。',
    image: 'https://readdy.ai/api/search-image?query=A%20luxurious%20brand%20endorsement%20photoshoot%20setting%20with%20professional%20equipment%2C%20golden%20and%20red%20accent%20colors%2C%20dramatic%20lighting%20with%20shadows%2C%20editorial%20commercial%20photography%20style&width=800&height=500&seq=card-5&orientation=landscape',
    stats: { views: '76.8万', comments: '2.1万' },
  },
  {
    id: 6,
    title: '网红主播偷税漏税被查，补缴金额超千万',
    tag: '社会关注',
    tagType: 'accent',
    excerpt: '税务部门近期对直播行业展开专项整治，某拥有千万粉丝的头部主播已被查实存在大规模偷逃税款行为，补缴税款及罚款合计超过一千二百万元，账号目前已被平台封禁。',
    image: 'https://readdy.ai/api/search-image?query=A%20luxury%20modern%20living%20room%20with%20streaming%20equipment%2C%20dramatic%20contrast%20between%20glamour%20and%20darkness%2C%20warm%20ambient%20lighting%2C%20editorial%20photojournalism%20style%2C%20moody%20atmosphere&width=800&height=500&seq=card-6&orientation=landscape',
    stats: { views: '145.2万', comments: '6.7万' },
  },
];

export const appData = {
  title: '手机刷瓜',
  subtitle: '下载黑料爆料 APP，第一时间接收最新黑料爆料推送，热门爆料不错过',
  features: ['实时推送', '独家内容', '离线阅读', '夜间模式'],
  downloadLinks: {
    ios: '#app',
    android: '#app',
  },
};

export const mediaData = [
  {
    id: 1,
    title: '独家专访：圈内人亲述某顶流团队如何操控舆论',
    duration: '18:42',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20dramatic%20interview%20setting%20with%20silhouette%20figure%20against%20warm%20studio%20lighting%2C%20anonymous%20whistleblower%20aesthetic%2C%20cinematic%20documentary%20style%2C%20moody%20atmosphere%20with%20red%20and%20gold%20accents&width=640&height=360&seq=media-1&orientation=landscape',
    views: '89.3万',
    tag: '独家',
    tagType: 'primary',
  },
  {
    id: 2,
    title: '实锤现场：某综艺后台监控画面完整流出',
    duration: '12:15',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20TV%20studio%20backstage%20monitor%20wall%20showing%20multiple%20camera%20feeds%2C%20dark%20control%20room%20with%20glowing%20screens%2C%20surveillance%20aesthetic%2C%20cinematic%20thriller%20style&width=640&height=360&seq=media-2&orientation=landscape',
    views: '67.8万',
    tag: '实锤',
    tagType: 'accent',
  },
  {
    id: 3,
    title: '十分钟看完本月最炸裂的五大爆料事件',
    duration: '10:28',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20dynamic%20news%20montage%20studio%20setup%20with%20multiple%20screens%20displaying%20breaking%20news%2C%20dramatic%20red%20and%20gold%20lighting%2C%20modern%20broadcast%20style%2C%20energetic%20atmosphere&width=640&height=360&seq=media-3&orientation=landscape',
    views: '132.5万',
    tag: '合集',
    tagType: 'primary',
  },
];

export const featuresData = [
  {
    id: 1,
    icon: 'ri-shield-flash-line',
    title: '信息多重核实',
    description: '每条爆料均经过至少三方信源交叉验证，确保内容真实可靠，杜绝虚假信息传播。我们坚持"不实不发"原则，对所有投稿进行严格审核。',
  },
  {
    id: 2,
    icon: 'ri-rocket-2-line',
    title: '全网最快速度',
    description: '遍布娱乐圈的线人网络确保我们总能在第一时间获取最新黑料爆料，比主流媒体平均快 6-8 小时。吃瓜群众的黄金时间，我们从不迟到。',
  },
  {
    id: 3,
    icon: 'ri-shield-user-line',
    title: '爆料人绝对保护',
    description: '采用多层匿名化处理技术，从投稿到发布全程加密，绝不泄露爆料人任何身份信息。你的安全，是我们最大的责任。',
  },
];

export const indexData = [
  { id: 1, title: '娱乐圈塌房实录', count: 47, tag: '热门', tagType: 'accent', icon: 'ri-building-4-line' },
  { id: 2, title: '网红翻车现场', count: 32, tag: '新晋', tagType: 'primary', icon: 'ri-live-line' },
  { id: 3, title: '综艺剧本揭秘', count: 28, tag: '深度', tagType: 'primary', icon: 'ri-tv-2-line' },
  { id: 4, title: '明星税务问题', count: 19, tag: '', tagType: '', icon: 'ri-money-dollar-circle-line' },
  { id: 5, title: '影视圈潜规则', count: 35, tag: '连载', tagType: 'accent', icon: 'ri-film-line' },
  { id: 6, title: '爱豆私生活', count: 56, tag: '热议', tagType: 'primary', icon: 'ri-heart-pulse-line' },
  { id: 7, title: '品牌代言风波', count: 23, tag: '', tagType: '', icon: 'ri-advertisement-line' },
  { id: 8, title: '综艺节目内幕', count: 41, tag: '更新', tagType: 'accent', icon: 'ri-mic-2-line' },
  { id: 9, title: '直播行业乱象', count: 30, tag: '追踪', tagType: 'primary', icon: 'ri-camera-lens-line' },
];

export const carouselData = [
  {
    id: 1,
    title: '某选秀节目背后的资本博弈：谁是真正的操盘手？',
    tag: '重磅专题',
    excerpt: '深入调查某热门选秀节目背后的投资方、经纪公司、平台三方博弈，揭开"造星流水线"的完整利益链条。从海选到出道，每一步都写满了资本的意志。',
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20stage%20with%20bright%20spotlights%20and%20long%20shadows%20behind%20the%20scenes%2C%20contrast%20between%20glamorous%20performance%20and%20dark%20backstage%2C%20theatrical%20lighting%20with%20red%20and%20gold%20accents%2C%20editorial%20photojournalism&width=1200&height=600&seq=carousel-1&orientation=landscape',
    date: '2026-07-28',
  },
  {
    id: 2,
    title: '从顶流到被封杀：一个流量明星的坠落全记录',
    tag: '深度追踪',
    excerpt: '复盘某顶流从爆红到全网封杀的完整时间线，梳理危机公关中的致命失误，以及背后多方力量的角力过程。这不是一个人的坠落，是整个行业的缩影。',
    image: 'https://readdy.ai/api/search-image?query=A%20solitary%20spotlight%20on%20empty%20stage%20with%20falling%20confetti%2C%20dramatic%20contrast%20lighting%2C%20melancholic%20atmosphere%2C%20editorial%20documentary%20style%2C%20warm%20golden%20and%20deep%20red%20tones&width=1200&height=600&seq=carousel-2&orientation=landscape',
    date: '2026-07-25',
  },
  {
    id: 3,
    title: '娱乐圈"阴阳合同"现象调查：偷逃税款的灰色地带',
    tag: '调查报道',
    excerpt: '本报独家获取多份疑似阴阳合同的影印件，揭示了娱乐圈长期存在的薪酬拆分、虚假发票、境外走账等逃税手段，涉及金额触目惊心。',
    image: 'https://readdy.ai/api/search-image?query=A%20stack%20of%20confidential%20documents%20on%20dark%20wooden%20desk%20under%20dramatic%20desk%20lamp%2C%20mysterious%20investigation%20aesthetic%2C%20warm%20ambient%20lighting%2C%20editorial%20photojournalism%20style&width=1200&height=600&seq=carousel-3&orientation=landscape',
    date: '2026-07-22',
  },
  {
    id: 4,
    title: '饭圈文化大起底：谁在操控粉丝的情绪和钱包？',
    tag: '特别策划',
    excerpt: '从粉头到站姐，从打投到应援，揭开饭圈经济背后的运作机制。职业粉丝、数据造假、集资跑路……这些词背后，是无数被收割的普通追星族。',
    image: 'https://readdy.ai/api/search-image?query=A%20crowd%20of%20fans%20holding%20light%20sticks%20at%20concert%2C%20dramatic%20stage%20lighting%20from%20above%2C%20contrast%20between%20crowd%20energy%20and%20individual%20isolation%2C%20editorial%20documentary%20style&width=1200&height=600&seq=carousel-4&orientation=landscape',
    date: '2026-07-20',
  },
  {
    id: 5,
    title: '替身、抠图、数字小姐：影视圈乱象何时休？',
    tag: '行业观察',
    excerpt: '演员不背台词念数字、全程替身拍摄、后期抠图合成……这些行业陋习如何形成？又是谁在默许甚至纵容？一线从业者匿名揭露行业内幕。',
    image: 'https://readdy.ai/api/search-image?query=A%20green%20screen%20film%20studio%20with%20empty%20director%20chair%2C%20contrast%20between%20professional%20equipment%20and%20absence%20of%20actors%2C%20dramatic%20lighting%2C%20editorial%20photojournalism%20style&width=1200&height=600&seq=carousel-5&orientation=landscape',
    date: '2026-07-18',
  },
  {
    id: 6,
    title: '某知名经纪公司"霸王条款"曝光：艺人的卖身契？',
    tag: '独家揭秘',
    excerpt: '一份长达47页的经纪合约范本被匿名投稿至本平台，其中多条条款被法律专家认定为"显失公平"。从收入分成到人身限制，艺人的权利被压缩到了极致。',
    image: 'https://readdy.ai/api/search-image?query=A%20long%20legal%20contract%20document%20on%20dark%20desk%20with%20dramatic%20lighting%2C%20mysterious%20and%20serious%20atmosphere%2C%20warm%20golden%20accents%2C%20editorial%20photojournalism%20style&width=1200&height=600&seq=carousel-6&orientation=landscape',
    date: '2026-07-15',
  },
];

export const topicsData = [
  { id: 1, name: '#某顶流深夜密会', heat: '987万', trend: 'up', posts: '12.8万', tagType: 'primary' },
  { id: 2, name: '#选秀节目内定名单', heat: '856万', trend: 'up', posts: '9.6万', tagType: 'accent' },
  { id: 3, name: '#网红偷税补缴千万', heat: '743万', trend: 'up', posts: '8.2万', tagType: 'primary' },
  { id: 4, name: '#导演婚内出轨实锤', heat: '698万', trend: 'hot', posts: '11.3万', tagType: 'accent' },
  { id: 5, name: '#花旦片场耍大牌', heat: '621万', trend: 'up', posts: '7.5万', tagType: '' },
  { id: 6, name: '#经纪公司霸王条款', heat: '587万', trend: 'new', posts: '5.8万', tagType: '' },
  { id: 7, name: '#流量小生天价代言', heat: '534万', trend: 'up', posts: '6.1万', tagType: '' },
  { id: 8, name: '#综艺剧本造假', heat: '498万', trend: 'up', posts: '8.9万', tagType: '' },
  { id: 9, name: '#饭圈集资跑路', heat: '465万', trend: 'hot', posts: '4.7万', tagType: '' },
  { id: 10, name: '#影视圈潜规则揭露', heat: '432万', trend: 'up', posts: '5.3万', tagType: '' },
  { id: 11, name: '#阴阳合同调查', heat: '389万', trend: 'up', posts: '3.9万', tagType: '' },
];

export const commentsData = [
  {
    id: 1,
    avatar: 'https://readdy.ai/api/search-image?query=A%20minimalist%20portrait%20avatar%20of%20anonymous%20whistleblower%2C%20dark%20silhouette%20style%2C%20mysterious%20mood%2C%20simple%20dark%20background&width=80&height=80&seq=avatar-1&orientation=squarish',
    nickname: '资深吃瓜人',
    time: '12分钟前',
    content: '这条爆料我第一时间就看到了，跟圈内朋友确认过，基本属实。现在的娱乐圈真的是一天一个瓜，根本吃不完，感谢黑料爆料给力！',
    likes: 2836,
    tag: '热门',
  },
  {
    id: 2,
    avatar: 'https://readdy.ai/api/search-image?query=A%20minimalist%20portrait%20avatar%20with%20mysterious%20vibe%2C%20dark%20silhouette%20on%20warm%20background%2C%20anonymous%20style%2C%20simple%20composition&width=80&height=80&seq=avatar-2&orientation=squarish',
    nickname: '圈内老炮',
    time: '28分钟前',
    content: '我在这个圈子混了十几年，可以负责任地说，爆出来的只是冰山一角。水面下的东西比你们想象的精彩一百倍，有些料现在还不敢报。',
    likes: 1954,
    tag: '精华',
  },
  {
    id: 3,
    avatar: 'https://readdy.ai/api/search-image?query=A%20minimalist%20anonymous%20avatar%20portrait%2C%20warm%20dark%20tones%2C%20mysterious%20aesthetic%2C%20simple%20clean%20composition%20on%20dark%20background&width=80&height=80&seq=avatar-3&orientation=squarish',
    nickname: '理性吃瓜不站队',
    time: '45分钟前',
    content: '建议大家理性看待，不要被带节奏。虽然这些黑料看起来很劲爆，但也要注意分辨真假。平台能有核实机制挺好的，点赞！',
    likes: 1567,
    tag: '',
  },
  {
    id: 4,
    avatar: 'https://readdy.ai/api/search-image?query=A%20minimalist%20portrait%20in%20anonymous%20style%2C%20warm%20dark%20color%20scheme%2C%20simple%20composition%2C%20mysterious%20vibe&width=80&height=80&seq=avatar-4&orientation=squarish',
    nickname: '夜猫子爆料站',
    time: '1小时前',
    content: '终于有人把这些事情说出来了！之前在其他平台发过类似的内容，秒被删。希望黑料爆料能扛住压力，我们吃瓜群众就是你们最坚强的后盾！',
    likes: 3215,
    tag: '爆款',
  },
  {
    id: 5,
    avatar: 'https://readdy.ai/api/search-image?query=A%20minimalist%20mysterious%20avatar%20portrait%2C%20dark%20warm%20aesthetic%2C%20anonymous%20figure%20style%2C%20simple%20clean%20composition&width=80&height=80&seq=avatar-5&orientation=squarish',
    nickname: '行业观察笔记',
    time: '2小时前',
    content: '从行业角度看，这些爆料反映的是整个娱乐产业的结构性问题。流量至上、数据造假、资本操控，这些问题不解决，类似的瓜永远不会停。',
    likes: 892,
    tag: '',
  },
];

export const rankingData = [
  { id: 1, rank: 1, title: '顶流男星深夜密会神秘女子，酒店共度8小时', heat: '128.6万', change: 'new', tagType: 'accent' },
  { id: 2, rank: 2, title: '当红花旦片场耍大牌？剧组工作人员集体爆料', heat: '96.3万', change: 'up', tagType: 'primary' },
  { id: 3, rank: 3, title: '知名导演婚内出轨，第三者竟是新片女主角', heat: '112.4万', change: 'up', tagType: 'primary' },
  { id: 4, rank: 4, title: '网红主播偷税漏税被查，补缴金额超千万', heat: '145.2万', change: 'down', tagType: '' },
  { id: 5, rank: 5, title: '综艺节目黑幕曝光：淘汰名单提前内定', heat: '87.1万', change: 'up', tagType: '' },
  { id: 6, rank: 6, title: '某流量小生代言费曝光，天价数字令人咋舌', heat: '76.8万', change: 'down', tagType: '' },
  { id: 7, rank: 7, title: '饭圈集资平台被曝资金链断裂，超万人维权', heat: '65.9万', change: 'new', tagType: '' },
];

export const contactData = {
  title: '你有料？我们有人！',
  subtitle: '如果你有娱乐圈、网红圈、直播圈的一手黑料爆料，欢迎通过以下方式联系我们。所有投稿均采用匿名处理，我们承诺绝不泄露爆料人信息。',
  email: 'tips@heiliaobaoliao.com',
  description: '投稿即视为授权本平台在核实后公开发布。我们会在收到投稿后 24 小时内完成初步审核并回复。重大爆料可加急处理。',
};

export const updatesData = [
  {
    id: 1,
    date: '2026-07-30',
    title: '关于某顶流男星深夜密会事件的后续进展',
    summary: '该男星工作室今日发布声明否认所有指控，但声明中存在多处时间线矛盾。本平台已获取酒店监控录像的部分截图，正在进行最后的核实工作，预计明日发布完整报道。',
    tag: '跟进中',
    tagType: 'primary',
  },
  {
    id: 2,
    date: '2026-07-29',
    title: '某选秀节目制作方回应淘汰名单泄露事件',
    summary: '制作方发表官方声明称淘汰结果"严格依据观众投票产生"，但拒绝公开原始投票数据。多位参赛选手经纪公司已联合向广电部门提交投诉材料。',
    tag: '回应',
    tagType: 'accent',
  },
  {
    id: 3,
    date: '2026-07-28',
    title: '网红偷税案最新：三名关联主播主动补缴税款',
    summary: '受头部主播偷税案影响，同属一家MCN机构的三名腰部主播已于昨日主动向税务部门补缴税款合计约380万元。业内人士预计，直播行业将迎来更大范围的税务自查潮。',
    tag: '发酵',
    tagType: 'primary',
  },
  {
    id: 4,
    date: '2026-07-27',
    title: '平台公告：黑料爆料每日大赛七月评选结果出炉',
    summary: '本月"黑料爆料每日大赛"共收到投稿爆料 1,247 条，经审核后公开发布 386 条。七月度冠军为"导演婚内出轨实锤"系列报道，累计阅读量超过 800 万次。',
    tag: '活动',
    tagType: 'accent',
  },
  {
    id: 5,
    date: '2026-07-26',
    title: '某经纪公司被曝拟起诉本平台，律师函已被我方接收',
    summary: '针对"经纪公司霸王条款"专题报道，涉事公司委托律师事务所发来律师函，称报道内容"严重失实"。本平台法务团队已启动应诉准备，所有报道证据链完整，欢迎对簿公堂。',
    tag: '对峙',
    tagType: 'primary',
  },
  {
    id: 6,
    date: '2026-07-25',
    title: '广电总局发布关于加强娱乐内容管理的通知',
    summary: '通知要求各平台加强对涉及明星隐私、不实传闻等内容的管理。本平台已第一时间组织学习，并优化了内容审核流程，确保所有报道在满足公众知情权的同时，符合相关法规要求。',
    tag: '政策',
    tagType: '',
  },
  {
    id: 7,
    date: '2026-07-24',
    title: '黑料爆料 APP 3.0 版本正式上线，全新界面等你体验',
    summary: '新版本增加了"专属爆料频道"、"AI 智能摘要"和"离线瓜包"三大功能。同时优化了推送速度和内容加载性能，iOS 和 Android 均已同步上架各大应用商店。',
    tag: '产品',
    tagType: '',
  },
];

export const aboutData = {
  title: '关于黑料爆料',
  paragraphs: [
    '黑料爆料成立于 2023 年，是国内领先的娱乐内容深度报道平台。我们专注于追踪娱乐圈、网红圈、直播圈的最新黑料爆料与热点事件，以"吃瓜群众的第一手信息来源"为使命，致力于为广大网友提供真实、全面、及时的娱乐深度内容。',
    '我们的编辑团队由资深娱乐记者、前经纪公司高管和一线法律顾问组成，确保每一条爆料都在法律框架内进行深度挖掘和多信源交叉验证。我们不制造谣言，我们只是事实的搬运工。',
    '自成立以来，黑料爆料已累计发布独家深度报道超过 2,000 篇，全网累计阅读量突破 50 亿次。我们始终坚持"内容为王、真实第一"的原则，在行业内建立了良好的口碑和公信力。',
  ],
  stats: [
    { value: '2000+', label: '独家报道' },
    { value: '50亿+', label: '累计阅读' },
    { value: '300万+', label: '日活用户' },
    { value: '98.7%', label: '真实率' },
  ],
};

export const faqData = [
  {
    id: 1,
    question: '黑料爆料的爆料信息真的靠谱吗？',
    answer: '本平台所有爆料均经过至少三方独立信源交叉验证后才予发布。我们的审核团队由前调查记者和法律顾问组成，对每一条信息进行严格的真实性核查。虽然我们不保证100%无误（因为信息来源本身的复杂性），但我们承诺每条发布的信息都经过了现阶段最高标准的核实流程。如果发现发布内容有误，我们会在第一时间更正并公开致歉。',
  },
  {
    id: 2,
    question: '我想投稿爆料，如何保护我的隐私安全？',
    answer: '我们采用业界领先的多层匿名化处理技术保护爆料人身份。投稿时您无需提供任何真实个人信息，系统会自动生成匿名ID。所有通信均经过端到端加密，原始投稿IP地址不记录、不存储。我们宁可少发一条爆料，也绝不会泄露任何爆料人的身份信息。自平台成立以来，从未发生过爆料人信息泄露事件。',
  },
  {
    id: 3,
    question: '收到律师函或被要求删帖怎么办？',
    answer: '本平台拥有专业的法务团队，对每篇报道在发布前都会进行法律合规审核。如果您认为某篇报道侵犯了您的合法权益，可以通过官方邮箱提交正式的删帖申请及相关证明材料。我们的法务团队会在 48 小时内完成审核：如报道确有不实之处，我们立即删除并公开更正；如报道内容属实且符合公众利益，我们将坚定维护报道权利，必要时通过法律途径解决争议。',
  },
  {
    id: 4,
    question: '黑料爆料每日大赛是什么？如何参与？',
    answer: '黑料爆料每日大赛是本平台的品牌活动，每天由读者投票评选当日最具爆点的黑料爆料。参与方式很简单：在平台注册后，每天可以为喜欢的爆料投出你神圣的一票。每月的月度冠军爆料人和爆料作者都会获得平台的现金奖励和专属勋章。我们不生产瓜，我们只是吃瓜大赛的组织者——让每一条真实的爆料，都能被更多人看到。',
  },
];